export enum IconTypes {
  CROSS = "cross",
  CHECK = "check",
}
